export default __webpack_public_path__ + "static/media/silhouette-girl3.5627d90d.svg";